<template>
  <el-dialog
    title="修改展示时间"
    :visible.sync="dialogVisible"
    width="450px"
    :close-on-click-modal="false"
    :show-close="true"
    center
    append-to-body
  >
    <div class="time-modify-content">
      <div class="warning-icon">
        <i class="el-icon-warning-outline"></i>
      </div>
      <div class="warning-message"> 展示时间已过，请修改后上架 </div>
      <div class="time-picker-container">
        <div class="time-label">展示时间</div>
        <el-date-picker
          v-model="dateRange"
          type="datetimerange"
          range-separator="—"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"
          :picker-options="pickerOptions"
          style="width: 100%"
          :default-time="['00:00:00', '23:59:59']"
        />
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">取消</el-button>
      <el-button type="primary" @click="handleConfirm">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
  export default {
    name: 'TimeModifyDialog',
    props: {
      visible: {
        type: Boolean,
        default: false
      },
      bannerId: {
        type: [Number, String],
        default: ''
      },
      currentStartTime: {
        type: String,
        default: ''
      },
      currentEndTime: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        dateRange: [],
        pickerOptions: {
          disabledDate(time) {
            return time.getTime() < Date.now() - 8.64e7 // 禁用今天之前的日期
          }
        }
      }
    },
    watch: {
      visible(val) {
        if (val && this.currentStartTime && this.currentEndTime) {
          this.dateRange = [this.currentStartTime, this.currentEndTime]
        }
      }
    },
    computed: {
      dialogVisible: {
        get() {
          return this.visible
        },
        set(val) {
          this.$emit('update:visible', val)
        }
      }
    },
    methods: {
      handleCancel() {
        this.dialogVisible = false
      },
      handleConfirm() {
        if (!this.dateRange || this.dateRange.length !== 2) {
          this.$message.warning('请选择展示时间')
          return
        }

        const [startTime, endTime] = this.dateRange

        // 验证结束时间是否大于当前时间
        if (new Date(endTime).getTime() <= Date.now()) {
          this.$message.warning('结束时间必须大于当前时间')
          return
        }

        // 验证结束时间是否大于开始时间
        if (new Date(endTime).getTime() <= new Date(startTime).getTime()) {
          this.$message.warning('结束时间必须大于开始时间')
          return
        }

        this.$emit('confirm', {
          id: this.bannerId,
          startTime,
          endTime
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .time-modify-content {
    display: flex;
    flex-direction: column;
    align-items: center;

    .warning-icon {
      font-size: 24px;
      color: #f56c6c;
      margin-bottom: 15px;

      i {
        font-size: 24px;
      }
    }

    .warning-message {
      font-size: 14px;
      color: #606266;
      text-align: center;
      margin-bottom: 20px;
      line-height: 1.5;
    }

    .time-picker-container {
      width: 100%;

      .time-label {
        margin-bottom: 10px;
        font-size: 14px;
        color: #606266;
      }
    }
  }

  .dialog-footer {
    text-align: center;
  }

  ::v-deep .el-dialog__header {
    padding: 15px;
    text-align: center;
    border-bottom: 1px solid #ebeef5;
  }

  ::v-deep .el-dialog__body {
    padding: 20px;
  }

  ::v-deep .el-dialog__title {
    font-size: 16px;
    font-weight: 500;
  }

  ::v-deep .el-dialog__headerbtn {
    top: 15px;
  }
</style>
